import { render, staticRenderFns } from "./MaiJiaAdvertising.vue?vue&type=template&id=2fcac206&scoped=true&"
import script from "./MaiJiaAdvertising.vue?vue&type=script&lang=js&"
export * from "./MaiJiaAdvertising.vue?vue&type=script&lang=js&"
import style0 from "./MaiJiaAdvertising.vue?vue&type=style&index=0&id=2fcac206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcac206",
  null
  
)

export default component.exports